import { USER_ROLE } from '../enums/user-role.enum';

export enum ReleasePortalType {
  TELCLOUD = 'TelCloud',
  TELCOBILL = 'TelcoBill',
  AGENT_PORTAL = 'AgentPortal',
}

export const releasePortalTypeOptions = [
  { id: ReleasePortalType.TELCLOUD, name: 'TELCLOUD' },
  { id: ReleasePortalType.TELCOBILL, name: 'TELCOBILL' },
  { id: ReleasePortalType.AGENT_PORTAL, name: 'AGENT PORTAL' },
];

export interface ReleaseNoteListItemType {
  id: string;
  versionNumber: string;
  title: string;
  date: string;
  message: string;
  releaseDate: string;
  status: string;
  primaryUpdateType: ReleaseNoteUpdateType | null;
  secondaryUpdateTypes: ReleaseNoteUpdateType[];
  notifications: ReleaseNotification[];
  isReleased: boolean;
  isPublic: boolean;
  isInternal: boolean;
  isAdminOnly: boolean;
  portalType: ReleasePortalType;
  newFeatures: string[];
  bugFixes: string[];
  performanceImprovements: string[];
  supportEmail: string;
  phoneNumber: string;
  createdBy: { id: number; email: string } | null;
}

export type ReleaseNoteUpdateType = {
  id: number;
  name: string;
};

export interface ReleaseNote {
  id?: number;
  title: string;
  versionNumber: string;
  releaseDate: string;
  status?: string;
  description: string;
  isReleased: boolean;
  newFeatures?: string;
  bugFixes?: string;
  performanceImprovements?: string;
  backupRequirement?: boolean;
  backupDetails?: string;
  supportEmail?: string;
  phoneNumber?: string;
  isAdminOnly: boolean;
  isInternal: boolean;
  isPublic: boolean;
  portalType?: ReleasePortalType;
  mainDeveloper: { id: number; firstname: string; lastname: string; email: string; role: USER_ROLE } | null;
  scheduledReleaseDate?: string;
  primaryUpdateType: ReleaseNoteUpdateType | null;
  secondaryUpdateTypes: ReleaseNoteUpdateType[];
  notifications?: ReleaseNotification[];
  media?: MediaType[];
}

export interface ReleaseNotesModalProps {
  isOpen: boolean;
  toggle: () => void;
  onSave: (note: ReleaseNote) => void;
  initialNote: Partial<ReleaseNote> | null;
  mode: 'create' | 'edit';
}

export interface ReleaseNotification {
  id: number;
  title: string;
  isRead: boolean;
  message: string;
  releaseNote: ReleaseNote;
  createdAt: string;
}

export interface MediaType {
  type: 'image' | 'video' | 'document';
  url?: string;
}

export type CreateReleaseNoteDto = {
  title: string;
  versionNumber: string;
  releaseDate: string;
  scheduledReleaseDate?: string | null;
  status?: string;
  description: string;
  newFeatures?: string[];
  bugFixes?: string[];
  performanceImprovements?: string[];
  backupRequirement?: boolean;
  backupDetails?: string;
  supportEmail?: string;
  phoneNumber?: string;
  isReleased: boolean;
  isPublic: boolean;
  isInternal: boolean;
  isAdminOnly: boolean;
  portalType: ReleasePortalType;
  mainDeveloperId?: number;
};

export type UpdateReleaseNoteDto = Partial<CreateReleaseNoteDto>;

export type PortalVersionDto = {
  versionNumber: string | null;
};
